import getIsPastStream from '@anm/helpers/stream/getIsPastStream';
import { DestinationStats, LiveStreamStatus } from 'types/stream';

import { DestinationWithStreamMeta } from '../../types';

export const getViewsText = (
  destinations: DestinationWithStreamMeta[],
  state: LiveStreamStatus,
  webinarStats?: DestinationStats
) => {
  const isPastStream = getIsPastStream(state);
  const statsKey = isPastStream ? 'maxViews' : 'currentViews';
  const webinarViews = webinarStats?.[statsKey] || 0;

  const suffix = state === 'INPROGRESS' ? ' watching' : '';
  const prefix = isPastStream ? 'Total views: ' : '';

  const views = destinations.reduce((acc, d) => acc + (d?.response?.stats?.[statsKey] || 0), webinarViews);

  const formattedViews = views > 1000 ? `${(views / 1000).toFixed(1)}k` : Math.max(0, views);

  return `${prefix}${formattedViews}${suffix}`;
};

export const getCommentsText = (
  destinations: DestinationWithStreamMeta[],
  state: LiveStreamStatus,
  webinarStats?: DestinationStats
) => {
  const suffix = state === 'INPROGRESS' ? ' comments' : '';
  const prefix = getIsPastStream(state) ? 'Total comments: ' : '';
  const webinarComments = webinarStats?.commentsCount || 0;

  const comments = destinations.reduce((acc, d) => acc + (d?.response?.stats?.commentsCount || 0), webinarComments);

  const formattedComments = comments > 1000 ? `${(comments / 1000).toFixed(1)}k` : comments;

  return `${prefix}${formattedComments}${suffix}`;
};
